import React from 'react';
import styled from 'styled-components';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import type { TooltipProps } from '@mui/material/Tooltip';
type Props = {
  backgroundcolor?: string;
  color?: string;
  fontSize?: number;
  lineHeight?: number;
  maxWidth?: number | 'none';
  padding?: number;
  overflowy?: string;
  fontWeight?: number | string;
};

/**
 * @deprecated
 */
const CustomToolTip = styled(({
  className,
  ...props
}: TooltipProps & Props) => {
  return <Tooltip enterTouchDelay={0} PopperProps={{
    popperOptions: {
      placement: 'auto'
    }
  }} {...props} classes={{
    popper: className
  }} />;
})(({
  theme,
  backgroundcolor,
  color,
  fontSize,
  lineHeight,
  maxWidth,
  padding,
  overflowy,
  fontWeight
}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: backgroundcolor ?? theme.colors?.textColor,
    borderRadius: '4px',
    color: color ?? theme.colors?.white,
    fontSize: `${fontSize ?? 12}px`,
    lineHeight: `${lineHeight ?? 21}px`,
    maxWidth: maxWidth ?? 300,
    padding: `${padding ?? 0}px`,
    overflow: overflowy ?? 'auto',
    fontWeight: fontWeight ?? 400
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: backgroundcolor ?? theme.colors?.textColor,
    '&::before': {
      color: backgroundcolor ?? theme.colors?.textColor
    }
  }
}));

/**
 * @deprecated
 */
export default CustomToolTip;